import React from 'react';
import ReactECharts from 'echarts-for-react';
import { EChartsOption } from 'echarts';

interface BaseChartProps {
  option: EChartsOption;
  style?: React.CSSProperties;
  className?: string;
  loading?: boolean;
  theme?: 'light' | 'dark';
}

const BaseChart: React.FC<BaseChartProps> = ({
  option,
  style = { height: '100%', width: '100%' },
  className = '',
  loading = false,
  theme = 'light'
}) => {
  // Use white background for light theme
  const chartOption = {
    ...option,
    backgroundColor: theme === 'light' ? '#ffffff' : 'transparent'
  };

  return (
    <div className={`w-full h-full ${className}`} style={{ minHeight: '200px', minWidth: '200px' }}>
      <ReactECharts
        option={chartOption}
        style={{ ...style, width: '100%', height: '100%' }}
        showLoading={loading}
        theme={theme}
        opts={{ renderer: 'canvas', width: 'auto', height: 'auto' }}
      />
    </div>
  );
};

export default BaseChart;